import { render, staticRenderFns } from "./search-icon-black.vue?vue&type=template&id=53d6564e&scoped=true&lang=pug&"
import script from "./search-icon-black.vue?vue&type=script&lang=js&"
export * from "./search-icon-black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6564e",
  null
  
)

export default component.exports